import { createSelector, Selector } from 'reselect'

import { NextStepsState } from './nextSteps.reducer'

import { RootState } from '~/core/store/root.reducer'

type GetNextSteps = Selector<RootState, NextStepsState>

const getNextSteps: GetNextSteps = (state: RootState) => state.nextSteps

export const selectIsNextStepsLoading = createSelector(
  getNextSteps,
  (nextSteps) => nextSteps.loading,
)

export const selectNextSteps = createSelector(getNextSteps, (nextSteps) => nextSteps.data)

export const selectNextStepsError = createSelector(
  getNextSteps,
  (nextSteps) => !!nextSteps.errorCode,
)
